import * as React from 'react';
export const WFSvg = React.forwardRef(function WFSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M11 7.5 12.5 9 11 10.5v-3Zm3.5-.5L13 8.5 11.5 7h3Zm0 4h-3L13 9.5l1.5 1.5Zm.5-3.5v3L13.5 9 15 7.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2 2h1v6H0V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M3 2h3v6H3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M3 2h3v1H3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M6 2h3v6H6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M9 8V2h.5v6.5H0V8z',
      }),
    ),
  );
});
WFSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var WF = {
  category: 'flag',
  colorable: false,
  name: 'WF',
  svg: WFSvg,
};
